export default __webpack_public_path__ + "static/media/request_to_join_coalition.a27124da.svg";